import React from "react";
import Avance from "./Avance";

const Render = (props, context) => {
  return (
    props.users && props.goals && props.ranking && props.users.length && props.goals.length && props.ranking.length ? (
    <div key={props.periodo} className="avance">
      <h2 className="bgGreyXXL bgNone violet mesTitle mtl mbl">{props.periodo}</h2>
      <ul className="avancesUl boxOdd horizontal clearfix mha">
        {props.users.map(user => (
          <Avance periodo={props.periodo} 
                  mes={props.mes} 
                  ranking={props.ranking} 
                  user={user} 
                  goals={props.goals.filter(goal => {return goal.userId === user.id;})} 
          />
        ))}
      </ul>
    </div>
    ) : null
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Avances/AvancesDelMes.js